//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageInputItem } from './WebsiteBlockTextAndMediaImageInputItem';
import { WebsiteCustomFieldContactFormInputItem } from './WebsiteCustomFieldContactFormInputItem';
import { WebsiteBlockInputItem } from './WebsiteBlockInputItem';
import { IWebsiteBlockInputItemHasImages } from './IWebsiteBlockInputItemHasImages';
import { WebsiteBlockContactFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockContactFormInputItem extends WebsiteBlockInputItem implements IWebsiteBlockInputItemHasImages {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageInputItem[] = [];
    ThankYouMessage: string | null = null;
    ContactFormType: WebsiteBlockContactFormType = WebsiteBlockContactFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.ContactForm;
    CustomFields: WebsiteCustomFieldContactFormInputItem[] = [];

    constructor(initializer?: Partial<Omit<WebsiteBlockContactFormInputItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockContactFormInputItem";
}
